import axios from 'axios';
import { RequestHandler } from '../../app/RequestHandler';
import {
  DisplayPopUpTypes,
  Filter,
  MotionTypeOptions,
  PopUpRequestObject,
  ShockAbsorberSolution,
  ShockAbsorberSolutionResponseDTO,
} from '../../interfaces';
import { FilterState } from './interfaces';

export const getResults = async (filters: FilterState) => {
  const { language, country } = new RequestHandler();

  const url = `/eac/${country}_${language}/shock-absorber-backend/shock-absorber?`;

  const options = {
    headers: {
      'Content-Type': `application/json`,
    },
  };
  const response = await axios.post<ShockAbsorberSolutionResponseDTO>(url, JSON.stringify(filters), options);

  return response;
};

export const getPopUpResult = async (popUpFilters: PopUpRequestObject, motionType: DisplayPopUpTypes) => {
  const { language, country } = new RequestHandler();

  const url = `/eac/${country}_${language}/shock-absorber-backend/pre-calculation?displayModeType=${motionType}`;

  const options = {
    headers: {
      'Content-Type': `application/json`,
    },
  };
  const response = await axios.post(url, JSON.stringify(popUpFilters), options);

  return response;
};

export const getFilterByMotionType = async (motionType: MotionTypeOptions) => {
  const { language, country } = new RequestHandler();

  const url = `/eac/${language}_${country}/shock-absorber-backend/filter-configuration?motionType=${motionType}`;

  const options = {
    headers: {
      'Content-Type': `application/json`,
    },
  };

  const response = await axios.get<Filter[]>(url, options);

  return response;
};
